import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=427a8a46&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=427a8a46&prod&lang=scss"
import style1 from "./SignUp.vue?vue&type=style&index=1&id=427a8a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a8a46",
  null
  
)

export default component.exports